import { formatDistanceToNow } from "date-fns";

export const formatRelative = (iso: string | null | undefined): string => {
  if (!iso) return "";
  try {
    return `${formatDistanceToNow(new Date(iso))} ago`;
  } catch {
    return "";
  }
};

interface UserLike {
  id: number;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
}

const displayName = (u: UserLike): string => {
  const full = `${u.first_name ?? ""} ${u.last_name ?? ""}`.trim();
  return full || u.email || "Unknown user";
};

export const authorNameFor = (
  userId: number | null | undefined,
  users: UserLike[] | undefined,
  currentUser?: UserLike | null
): string => {
  if (userId == null) return "Unknown user";
  // The current user may not appear in `users` (e.g. the service user is
  // filtered out of the org list), so resolve self from `currentUser`
  // before falling back to the list.
  if (currentUser && currentUser.id === userId) return displayName(currentUser);
  const u = users?.find(x => x.id === userId);
  return u ? displayName(u) : "Unknown user";
};
